import { render, staticRenderFns } from "./FreePlanCard.vue?vue&type=template&id=17e1f17a&scoped=true&"
import script from "./FreePlanCard.vue?vue&type=script&lang=js&"
export * from "./FreePlanCard.vue?vue&type=script&lang=js&"
import style0 from "./FreePlanCard.vue?vue&type=style&index=0&id=17e1f17a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1f17a",
  null
  
)

export default component.exports